export enum ProcessActionNotificationType {
        ActionAppraiseeNotification = 0,
        ActionAppraiseeReminder = 1,
        RespondentsConfirmedByHrAppraiseeNotification = 2,
        EndProcessAppraiseeNotification = 3,
        NewSurveyRespondentNotification = 4,
        NewSurveyRespondentReminder = 5,
        ProcessStartPmNotification = 6,
        EndProcessPmNotification = 7,
        RespondentConfirmPmReminder = 8,
        RespondentsConfirmedByHrPmNotification = 9,
        RespondentConfirmHrNotification = 10,
        RespondentConfirmHrReminder = 11,
        EndProcessHrNotification = 12
}